import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private jwtHelper: JwtHelperService;

  constructor() {
    this.jwtHelper = new JwtHelperService();
  }

  isTokenExpired(token: string): boolean {
    return this.jwtHelper.isTokenExpired(token);
  }

  getExpirationDate(token: string): Date | null {
    const decodedToken = this.jwtHelper.decodeToken(token);
    if (!decodedToken || !decodedToken.exp) {
      return null;
    }
    const expirationDate = new Date(0);
    expirationDate.setUTCSeconds(decodedToken.exp);
    return expirationDate;
  }
  getTimeUntilExpiration(token: any): number | null {
    const expirationDate = this.getExpirationDate(token);
    if (!expirationDate) {
      return null;
    }
    const currentTime = new Date().getTime();
    return expirationDate.getTime() - currentTime; 
  }
}
